import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModulesComponent } from './modules.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddModuleComponent } from './add-module/add-module.component';
import { EditModuleComponent } from './edit-module/edit-module.component';

@NgModule({
	declarations: [
		ModulesComponent,
		AddModuleComponent,
		EditModuleComponent
	],
	imports: [
		CommonModule, FormsModule, ReactiveFormsModule, MaterialModule
	],
	exports: [ModulesComponent],
})
export class ModulesModule { }